import { createBrowserClient } from "@supabase/ssr";
import { Database } from "@/lib/database.types";

let _client: ReturnType<typeof createBrowserClient> | undefined;

export const createClient = () => {
  if (!_client) {
    _client = createBrowserClient<Database>(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      {
        auth: {
          flowType: "pkce",
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
      }
    );
  }
  return _client;
};
